import { injectScript } from './script-loader.service';

export const initializeFacebookPixel = (pixelId: string): boolean => {
  if (!pixelId) return false;
  
  try {
    // Injeta o script do Facebook Pixel
    const fbScript = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${pixelId}');
      // multi-pixel safe: evita enviar PageView para todos pixels já inicializados
      fbq('trackSingle', '${pixelId}', 'PageView');
    `;
    
    injectScript(fbScript);
    

    
    return true;
  } catch (error) {
    console.error(`❌ Facebook Pixel - Erro ao inicializar ${pixelId}:`, error);
    return false;
  }
}; 